/* Haalora Mist Model v6 (custom 'Your own car' upload): model picker, 1, 2 or 3 models, cart, video and sticky bar. Texts come from data.i18n (English fallback). */
(function () {
  function init(root) {
    if (!root || root.__nvp) return;
    root.__nvp = true;
    var dataEl = root.querySelector('script[data-nvp-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data.variants || !data.variants.length) return;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var cur = data.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var loc = data.locale || document.documentElement.lang || 'en';
    var fmt;
    try { fmt = new Intl.NumberFormat(loc, { style: 'currency', currency: cur }); } catch (e) { fmt = new Intl.NumberFormat('en', { style: 'currency', currency: cur }); }
    var money = function (c) { return fmt.format(c / 100); };
    var byId = function (id) { return data.variants.filter(function (x) { return x.id === id; })[0]; };
    var each = function (sel, fn) { root.querySelectorAll(sel).forEach(fn); };
    var first = byId(data.current) || data.variants[0];
    var picks = [first, first, first];
    var touched = [false, false, false];
    var pct = parseInt(data.pct, 10) || 0;
    /* 3 models: 1 free plus a fixed extra discount (EUR 10, matches the automatic discount "3 models: extra EUR 10 off"), converted to the shopper's currency. */
    var rate = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || '1') || 1;
    var extra3 = Math.round((typeof data.extra3 === 'number' ? data.extra3 : 1000) * rate);
    var checked = root.querySelector('input[data-nvp-q]:checked');
    var qty = checked ? (parseInt(checked.value, 10) || 1) : 1;
    var img = root.querySelector('[data-nvp-img]');
    var selS = root.querySelector('[data-sel-s]');
    var vid = root.querySelector('[data-nvp-vid]');
    var T = data.i18n || {};
    var tr = function (k, d) { return (typeof T[k] === 'string' && T[k]) ? T[k] : d; };
    var fill = function (t, v) { return String(t).split('[x]').join(String(v)); };
    var cu = data.cu || null;
    var cuOn = !!(cu && /[?&]custom=1(&|$)/.test(window.location.search));
    var cuFile = null;

    function hideVid() { if (vid && !vid.hidden) { try { vid.pause(); } catch (e) {} vid.hidden = true; } }
    function showVid() {
      if (!vid) return;
      vid.hidden = false;
      try { var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e) {}
    }
    if (vid && !vid.hidden && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      try { vid.removeAttribute('autoplay'); vid.pause(); } catch (e) {}
    }

    function fullFor(n) { var t = 0; for (var i = 0; i < n; i++) t += picks[i].price; return t; }
    function payFor(n) {
      var f = fullFor(n);
      if (n === 2) return f - Math.floor(picks[0].price * pct / 100) - Math.floor(picks[1].price * pct / 100);
      if (n === 3) return Math.max(0, f - Math.min(picks[0].price, picks[1].price, picks[2].price) - extra3);
      return f;
    }
    function canBuy() { for (var i = 0; i < qty; i++) { if (!picks[i].available) return false; } return true; }

    function applyCu() {
      if (!cu) return;
      each('[data-std]', function (el) { el.hidden = cuOn; });
      each('[data-cu-panel]', function (el) { el.hidden = !cuOn; });
      each('[data-cu-tile]', function (b) { b.classList.toggle('is-on', cuOn); b.setAttribute('aria-pressed', cuOn ? 'true' : 'false'); });
      if (!cuOn) return;
      each('[data-vid]', function (b) { b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); });
      each('[data-pay]', function (el) { el.textContent = money(cu.price); });
      each('[data-forlbl]', function (el) { el.textContent = cu['for']; });
      each('[data-was]', function (el) { el.hidden = true; });
      each('[data-savebadge]', function (el) { el.hidden = true; });
      each('[data-eachrow]', function (el) { el.hidden = true; });
      each('[data-nudge]', function (el) { el.hidden = true; });
      each('[data-vname]', function (el) { el.textContent = cu.title; });
      if (img && cu.img && img.getAttribute('data-cur') !== 'cu') { img.src = cu.img; img.removeAttribute('srcset'); img.setAttribute('data-cur', 'cu'); }
      var tsc = root.querySelector('[data-thumb-s]');
      if (tsc && cu.th) tsc.src = cu.th;
      each('[data-nvp-atc]', function (b) { b.disabled = false; });
      each('[data-atc-label]', function (el) { el.textContent = data.atc; });
    }

    function render() {
      var cv = picks[0];
      for (var n = 1; n <= 3; n++) {
        each('[data-p="' + n + '"]', function (el) { el.textContent = money(payFor(parseInt(el.getAttribute('data-p'), 10))); });
        each('[data-s="' + n + '"]', function (el) { el.textContent = money(fullFor(parseInt(el.getAttribute('data-s'), 10))); });
        each('[data-e="' + n + '"]', function (el) { var k = parseInt(el.getAttribute('data-e'), 10); el.textContent = money(Math.round(payFor(k) / k)); });
        each('[data-v="' + n + '"]', function (el) { var k = parseInt(el.getAttribute('data-v'), 10); el.textContent = fill(tr('save', 'SAVE [x]'), money(fullFor(k) - payFor(k))); });
      }
      each('[data-pay]', function (el) { el.textContent = money(payFor(qty)); });
      each('[data-was]', function (el) { el.textContent = money(fullFor(qty)); el.hidden = qty === 1; });
      each('[data-savebadge]', function (el) { el.hidden = qty === 1; el.textContent = qty === 3 ? tr('free1', '1 FREE') : tr('savepct', 'SAVE ' + pct + '%'); });
      each('[data-forlbl]', function (el) { el.textContent = qty === 1 ? tr('for1', 'for 1 model') : fill(tr('forN', 'for [x] models'), qty); });
      each('[data-each]', function (el) { el.textContent = money(Math.round(payFor(qty) / qty)); });
      each('[data-eachrow]', function (el) { el.hidden = qty === 1; });
      each('[data-nudge]', function (el) { el.hidden = qty !== 1; });
      each('[data-nudge-save]', function (el) { el.textContent = fill(tr('saveparen', '(save [x])'), money(fullFor(2) - payFor(2))); });
      each('[data-vname]', function (el) { el.textContent = cv.title; });
      each('[data-vid]', function (b) { var on = parseInt(b.getAttribute('data-vid'), 10) === cv.id; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      each('select[data-pick]', function (s) { var k = parseInt(s.getAttribute('data-pick'), 10) - 1; if (picks[k]) s.value = String(picks[k].id); });
      each('img[data-th]', function (t) { var k = parseInt(t.getAttribute('data-th'), 10) - 1; if (picks[k] && picks[k].th) t.src = picks[k].th; });
      if (selS) selS.value = String(cv.id);
      var ts = root.querySelector('[data-thumb-s]');
      if (ts && cv.th) ts.src = cv.th;
      if (img && cv.img && img.getAttribute('data-cur') !== String(cv.id)) { img.src = cv.img; img.removeAttribute('srcset'); img.setAttribute('data-cur', String(cv.id)); }
      var ok = canBuy();
      each('[data-nvp-atc]', function (b) { b.disabled = !ok; });
      each('[data-atc-label]', function (el) { el.textContent = ok ? data.atc : data.soon; });
      each('[data-picks]', function (el) { el.hidden = parseInt(el.getAttribute('data-picks'), 10) !== qty; });
      each('[data-box]', function (el) { el.classList.toggle('is-on', parseInt(el.getAttribute('data-box'), 10) === qty); });
      applyCu();
    }

    function setCur(id) {
      var f = byId(id);
      if (!f) return;
      cuOn = false;
      picks[0] = f;
      for (var k = 1; k < 3; k++) { if (!touched[k]) picks[k] = f; }
      hideVid();
      render();
    }

    each('[data-vid]', function (btn) { btn.addEventListener('click', function () { setCur(parseInt(btn.getAttribute('data-vid'), 10)); }); });
    if (selS) selS.addEventListener('change', function () { setCur(parseInt(selS.value, 10)); });
    each('select[data-pick]', function (s) {
      s.addEventListener('change', function () {
        var k = parseInt(s.getAttribute('data-pick'), 10) - 1;
        var id = parseInt(s.value, 10);
        if (k === 0) { setCur(id); return; }
        var f = byId(id);
        if (f) { picks[k] = f; touched[k] = true; render(); }
      });
    });
    each('input[data-nvp-q]', function (r) { r.addEventListener('change', function () { if (r.checked) { qty = parseInt(r.value, 10) || 1; render(); } }); });
    each('[data-nudge]', function (b) {
      b.addEventListener('click', function () {
        var r = root.querySelector('input[data-nvp-q][value="2"]');
        if (!r) return;
        r.checked = true;
        qty = 2;
        render();
        var box = root.querySelector('[data-box="2"]');
        if (box && box.scrollIntoView) { try { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { box.scrollIntoView(); } }
      });
    });
    each('.nvp-thumb', function (t) {
      t.addEventListener('click', function () {
        if (t.hasAttribute('data-vid-thumb')) { showVid(); return; }
        hideVid();
        if (img) { img.src = t.getAttribute('data-src'); img.removeAttribute('srcset'); img.removeAttribute('data-cur'); }
      });
    });

    function add() {
      if (cuOn && cu) { cuAdd(); return; }
      var btns = root.querySelectorAll('[data-nvp-atc]');
      var err = root.querySelector('[data-nvp-error]');
      btns.forEach(function (b) { b.disabled = true; });
      if (err) err.hidden = true;
      var map = {}, items = [];
      for (var i = 0; i < qty; i++) {
        var x = picks[i];
        if (map[x.id]) { map[x.id].quantity += 1; } else { map[x.id] = { id: x.id, quantity: 1 }; items.push(map[x.id]); }
      }
      if (data.pre) { var pk = data.prekey || 'Delivery'; items.forEach(function (it) { var pr = {}; pr[pk] = data.pre; it.properties = pr; }); }
      fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { window.location.href = base + 'cart'; })
        .catch(function () { if (err) err.hidden = false; btns.forEach(function (b) { b.disabled = !canBuy(); }); });
    }
    each('[data-nvp-atc]', function (b) { b.addEventListener('click', add); });

    /* Custom 'Your own car': photo + name go to the cart as line item properties (the photo is uploaded by Shopify). */
    var cuPanel = root.querySelector('[data-cu-panel]');
    var cuInput = root.querySelector('[data-cu-file]');
    var cuName = root.querySelector('[data-cu-name]');
    var cuErr = root.querySelector('[data-cu-err]');
    var cuBtn = root.querySelector('[data-cu-add]');
    function cuShowErr(t) { if (cuErr) { cuErr.textContent = t; cuErr.hidden = !t; } }
    function cuScroll() { if (cuPanel && cuPanel.scrollIntoView) { try { cuPanel.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { cuPanel.scrollIntoView(); } } }
    function isImg(f) { return !!f && (/^image\//.test(f.type || '') || /\.(jpe?g|png|webp|gif|heic|heif)$/i.test(f.name || '')); }
    function shrink(f) {
      return new Promise(function (res) {
        if (!/^image\/(jpeg|png|webp)$/.test(f.type || '') || f.size < 1500000 || !window.URL || !document.createElement('canvas').toBlob) { res(f); return; }
        var u = URL.createObjectURL(f), im = new Image();
        im.onload = function () {
          try {
            var mx = 2200, w = im.naturalWidth, h = im.naturalHeight, k = Math.min(1, mx / Math.max(w, h));
            var c = document.createElement('canvas'); c.width = Math.round(w * k); c.height = Math.round(h * k);
            c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
            c.toBlob(function (b) { URL.revokeObjectURL(u); if (!b || b.size >= f.size) { res(f); return; } var n = (f.name || 'car').replace(/\.[^.]+$/, '') + '.jpg'; try { res(new File([b], n, { type: 'image/jpeg' })); } catch (e) { b.name = n; res(b); } }, 'image/jpeg', 0.88);
          } catch (e) { URL.revokeObjectURL(u); res(f); }
        };
        im.onerror = function () { URL.revokeObjectURL(u); res(f); };
        im.src = u;
      });
    }
    function cuAdd() {
      if (!cu) return;
      var nm = cuName ? String(cuName.value || '').trim() : '';
      if (!cuFile) { cuShowErr(cu.ePhoto); cuScroll(); return; }
      if (!nm) { cuShowErr(cu.eName); cuScroll(); if (cuName) { try { cuName.focus({ preventScroll: true }); } catch (e) { cuName.focus(); } } return; }
      cuShowErr('');
      var btns = root.querySelectorAll('[data-nvp-atc],[data-cu-add]');
      btns.forEach(function (b) { b.disabled = true; });
      var lbl = cuBtn ? cuBtn.textContent : '';
      if (cuBtn) cuBtn.textContent = cu.busy;
      shrink(cuFile).then(function (f) {
        var fd = new FormData();
        fd.append('id', String(cu.id));
        fd.append('quantity', '1');
        fd.append('properties[' + cu.kCar + ']', nm);
        fd.append('properties[' + cu.kPhoto + ']', f, f.name || 'car.jpg');
        if (cu.kDel && cu.date) fd.append('properties[' + cu.kDel + ']', cu.date);
        return fetch(base + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
      }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { window.location.href = base + 'cart'; })
        .catch(function () {
          var ge = root.querySelector('[data-nvp-error]');
          cuShowErr(ge ? ge.textContent : 'Error');
          if (cuBtn) cuBtn.textContent = lbl;
          btns.forEach(function (b) { b.disabled = false; });
        });
    }
    if (cu) {
      each('[data-cu-tile]', function (b) { b.addEventListener('click', function () { cuOn = true; hideVid(); render(); if (window.innerWidth < 900) cuScroll(); }); });
      if (cuBtn) cuBtn.addEventListener('click', cuAdd);
      if (cuName) cuName.addEventListener('input', function () { if (cuErr && !cuErr.hidden) cuShowErr(''); });
      if (cuInput) cuInput.addEventListener('change', function () {
        var f = cuInput.files && cuInput.files[0];
        if (!f) return;
        if (!isImg(f)) { cuFile = null; cuShowErr(cu.eType); return; }
        cuFile = f; cuShowErr('');
        var pv = root.querySelector('[data-cu-prev]'), ic = root.querySelector('[data-cu-ic]'), pk = root.querySelector('[data-cu-pick]');
        if (pk) pk.textContent = (f.name ? f.name + ' · ' : '') + cu.change;
        if (pv && window.URL) { pv.onerror = function () { pv.hidden = true; if (ic) ic.hidden = false; }; pv.onload = function () { pv.hidden = false; if (ic) ic.hidden = true; }; pv.src = URL.createObjectURL(f); }
      });
    }


    /* Sticky bar: visible once the price row has scrolled out of view and the main button is not visible, so the button is always within reach on mobile. Works with any scroll container. */
    var sticky = root.querySelector('[data-nvp-sticky]');
    var mainBtn = root.querySelector('.nvp-actions [data-nvp-atc]');
    var anchor = root.querySelector('.nvp-price-row') || mainBtn;
    if (sticky && mainBtn && anchor && 'IntersectionObserver' in window) {
      var mainVisible = true;
      var shown = null;
      var upd = function () {
        var show = !mainVisible && anchor.getBoundingClientRect().bottom < 0;
        if (show === shown) return;
        shown = show;
        sticky.classList.toggle('is-on', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelectorAll('select,button').forEach(function (el) { el.tabIndex = show ? 0 : -1; });
      };
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.target === mainBtn) mainVisible = e.isIntersecting; });
        upd();
      }).observe(mainBtn);
      document.addEventListener('scroll', upd, { passive: true, capture: true });
      window.addEventListener('resize', upd, { passive: true });
    }
    render();
    if (cuOn) { setTimeout(cuScroll, 300); }

    /* Mobile model strip: make sure the chosen model is in view. */
    var strip = root.querySelector('.nvp-models');
    var act = strip ? strip.querySelector('.nvp-m.is-on') : null;
    if (strip && act && strip.scrollWidth > strip.clientWidth + 4) {
      var sr = strip.getBoundingClientRect(), ar = act.getBoundingClientRect();
      if (ar.left < sr.left || ar.right > sr.right) strip.scrollLeft += ar.left - sr.left - 8;
    }
  }
  function run() { document.querySelectorAll('[data-nvp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();